export default "__VITE_ASSET__B00u_Xm3__"